var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJurisdiction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3603 20.3H1.84886C1.40598 20.3 1 20.6691 1 21.1489C1 21.6287 1.36907 21.9977 1.84886 21.9977H14.3234C14.7663 21.9977 15.1723 21.6287 15.1723 21.1489C15.1723 20.6691 14.8032 20.3 14.3603 20.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39909 8.62647C7.3591 7.08805 8.58758 5.73647 10.0317 4.62988L16.2668 10.1913C15.3068 11.7297 14.0783 13.0813 12.6341 14.1878L6.39909 8.62647Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5601 14.2609L16.5415 12.081L22.3076 16.7043C23.1398 17.3743 23.236 18.5982 22.5194 19.3866C21.8027 20.175 20.5639 20.2082 19.8043 19.4583L14.5601 14.2609Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38113 10.116C4.92933 9.51283 5.86331 9.46434 6.47215 10.0074L11.2401 14.2602C11.849 14.8033 11.8979 15.7285 11.3497 16.3316C10.8015 16.9347 9.86753 16.9832 9.25869 16.4402L4.49071 12.1874C3.88188 11.6443 3.83293 10.7191 4.38113 10.116Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3161 2.48611C11.8643 1.88299 12.7983 1.8345 13.4072 2.37755L18.1751 6.63037C18.784 7.17343 18.8329 8.09865 18.2847 8.70177C17.7365 9.30489 16.8025 9.35338 16.1937 8.81033L11.4257 4.55751C10.8169 4.01445 10.7679 3.08923 11.3161 2.48611Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJurisdiction);
export default __webpack_public_path__ + "static/media/jurisdiction.cbe20c948b3593984bb5d2b5e3846eb9.svg";
export { ForwardRef as ReactComponent };